import { render, staticRenderFns } from "./MerchantAuthUpload.vue?vue&type=template&id=12331582&scoped=true"
import script from "./MerchantAuthUpload.vue?vue&type=script&lang=js"
export * from "./MerchantAuthUpload.vue?vue&type=script&lang=js"
import style0 from "./MerchantAuthUpload.vue?vue&type=style&index=0&id=12331582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12331582",
  null
  
)

export default component.exports